import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import styles from "./styles.module.scss"

export default {
	img: (
		<StaticImage
			className={styles.registrationSuccess__img}
			src="./assets/trial.png"
			breakpoints={[288, 570, 811, 1622, 674, 1348]}
			sizes="(max-width: 500px) 288px, (max-width: 1319px) 811px, (min-width: 1320px) 674px"
			alt="Акционные программы в ресторане"
			objectFit="contain"
			placeholder="blurred"
			quality={90}
		/>
	),
	title: "Вау, поздравляем!",
	description:
		"Теперь вам доступны все возможности Quick Resto. Пароль мы отправили вам на номер",
	cloudAddressLabel: "Адрес вашего облака",
	cloudAddress: "https://demowl.quickresto.ru",
	linkText: "Перейти в бэк-офис",
}
